// _DebugLog.js
const STORAGE_KEY = 'debug_logs';
const DEFAULT_MAX_LOGS = 30;

const createDebug = () =>
{
    let subscribers = [];
    let maxLogs = DEFAULT_MAX_LOGS;

    const loadLogs = () =>
    {
        try 
        {
            const storedLogs = localStorage.getItem(STORAGE_KEY);
            return storedLogs ? JSON.parse(storedLogs) : [];
        } 
        catch (error) 
        {
            console.error('Error loading debug logs:', error);
            return [];
        }
    };

    const saveLogs = (logs) =>
    {
        try 
        {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(logs));
        } 
        catch (error) 
        {
            console.error('Error saving debug logs:', error);
        }
    };

    const log = (...args) =>
    {
        // Still output to regular console
        console.log(...args);
        
        // Create formatted log entry
        const timestamp = new Date().toLocaleTimeString();
        const logMessage = args.map(arg => 
            typeof arg === 'object' ? JSON.stringify(arg, null, 2) : String(arg)
        ).join(' ');
        
        // Create log entry with timestamp
        const entry = `[${timestamp}] ${logMessage}`;

        // Load existing logs
        const logs = loadLogs();
        
        // Add new log and limit the number of entries
        const updatedLogs = [entry, ...logs].slice(0, maxLogs);
        
        // Save back to localStorage
        saveLogs(updatedLogs);
        
        // Notify all subscribers
        subscribers.forEach(callback => 
        {
            callback(updatedLogs);
        }
        );
    };

    const subscribe = (callback) =>
    {
        subscribers.push(callback);
        // Send current logs immediately to new subscriber
        callback(loadLogs());
        return () =>
        {
            subscribers = subscribers.filter(cb => cb !== callback);
        };
    };

    const clear = () =>
    {
        saveLogs([]);
        subscribers.forEach(callback => 
        {
            callback([]);
        }
        );
    };

    const setMaxLogs = (limit) =>
    {
        maxLogs = limit;
        // Trim existing logs if they exceed the new limit
        const logs = loadLogs();
        if (logs.length > limit) 
        {
            const trimmedLogs = logs.slice(0, limit);
            saveLogs(trimmedLogs);
            subscribers.forEach(callback => 
            {
                callback(trimmedLogs);
            }
            );
        }
    };

    return {
        log,
        subscribe,
        clear,
        setMaxLogs
    };
};

export const debug = createDebug();